<template>
  <div>
    <highcharts :options="chartOptions" style="height: 600px; width: 90%; margin: auto; padding: 25px;"></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";

export default {
  props: {
    xaxis: { type: Array, default: () => [] },
    incomingData: { type: Array, default: () => [] },
    outgoingData: { type: Array, default: () => [] },
  },
  data() {
    return {
      chartOptions: {
        chart: { type: "column" },
        title: { text: "" },
        xAxis: { categories: this.xaxis },
        yAxis: {
          min: 0,
          title: { text: "عدد المكالمات" },
          allowDecimals: false,
        },
        tooltip: {
          shared: true,
          useHTML: true,
          formatter: function () {
            let s = "<b>" + this.x + "</b><br/>";
            this.points.forEach((p) => {
              s += p.series.name + ": <b>" + p.y + "</b><br/>";
            });
            return s;
          },
        },
        plotOptions: {
          column: {
            pointWidth: 22,
            borderRadius: 3,
          },
        },
        series: [
          {
            name: "واردة",
            data: this.incomingData,
            color: "#1565C0",
          },
          {
            name: "صادرة",
            data: this.outgoingData,
            color: "#7E1280",
          },
        ],
      },
    };
  },
  watch: {
    xaxis(val) {
      this.chartOptions.xAxis.categories = val;
    },
    incomingData(val) {
      this.chartOptions.series[0].data = val;
    },
    outgoingData(val) {
      this.chartOptions.series[1].data = val;
    },
  },
  components: {
    highcharts: Chart,
  },
};
</script>
